// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NCNkLD{margin-bottom:20px;font-size:30px;text-align:center}@media (max-width: 599px){.NCNkLD{font-size:24px}}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `NCNkLD`
};
export default ___CSS_LOADER_EXPORT___;
